export default __webpack_public_path__ + "static/media/logo-fr.1983e471.svg";